var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.createProps)?_c(_vm.componentObject.component,_vm._g(_vm._b({tag:"component"},'component',_vm.componentObject.props,false),_vm.componentObject.vOn)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }